import { useState } from 'react'
import { Container } from '@ui/wrapper'
import Accordion from '@ui/accordion'
import { SectionWrapper, StyledText } from './style'

const BIBArea = ({ data, ...rest }) => {
  const [openAccordion, setOpenAccordion] = useState(0)

  const handleAccordionToggle = (index) => {
    setOpenAccordion(openAccordion === index ? null : index)
  }

  return (
    <SectionWrapper {...rest}>
      <Container>
        {data?.items?.length >= 2 && (
          <StyledText>
            <Accordion
              data={data.items}
              disableDefaultActive
              activeKey={
                data.items.map((item) => item.id).includes(openAccordion)
                  ? openAccordion
                  : null
              }
              onSelect={handleAccordionToggle}
            />
          </StyledText>
        )}
      </Container>
    </SectionWrapper>
  )
}

export default BIBArea
